<template>
    <div class="Partner-join">
        <!-- <div class="crumb" v-if="clientWidth > 750">
            <breadcrumb :refer="refer"></breadcrumb>
        </div> -->
        <div class="register">
            <div class="register-body">
                <div class="register-content" :class="clientWidth > 750 ? 'flex0' : ''">
                <div class="register-detail">
                    <h1>马上加入</h1>
                    <el-form :model="registerForm" :rules="rules" ref="registerForm" class="registerForm">
                    <el-form-item prop="cN_Name" label="合作伙伴中文名">
                        <el-input v-model.trim="registerForm.cN_Name" :disabled="IsHaveCompany" placeholder="请输入合作伙伴中文名"></el-input>
                    </el-form-item>
                    <el-form-item prop="eN_Name" label="英合作伙伴文名">
                        <el-input v-model.trim="registerForm.eN_Name" placeholder="请输入合作伙伴英文名"></el-input>
                    </el-form-item>
                    <el-form-item prop="type" label="合作伙伴所属类型">
                        <el-select v-model="registerForm.type" placeholder="请选择合作伙伴所属类型">
                            <el-option v-for="item in typeList" :key="item.title" :label="item.title" :value="item.title"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="business" label="业务范围">
                        <el-select v-model="registerForm.business" placeholder="请选择业务范围">
                            <el-option v-for="item in serviceList" :key="item.title" :label="item.title" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="abstract" label="公司简介">
                        <el-input type="textarea" v-model.trim="registerForm.abstract" maxlength="1000" placeholder="请输入公司简介，100 字以内"></el-input>
                    </el-form-item>
                    <el-form-item prop="contact" label="联系人">
                        <el-input v-model.trim="registerForm.contact" placeholder="请输入联系人"></el-input>
                    </el-form-item>
                    <el-form-item prop="phone" label="联系电话">
                        <el-input v-model.trim="registerForm.phone" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item prop="email" class="form-item email_input" label="邮箱">
                        <el-input v-model.trim="registerForm.email" placeholder="请输入您的邮箱地址"></el-input>
                    </el-form-item>
                    <el-form-item prop="websiteUrl" label="公司官网">
                        <el-input v-model.trim="registerForm.websiteUrl" placeholder="请输入公司官网"></el-input>
                    </el-form-item>
                    <el-form-item prop="logoUrl" label="公司 logo" class="word_input">
                        <div class="upload-box">
                            <div class="up-img">
                                <el-image v-if="registerForm.logoUrl" :src="registerForm.logoUrl" :preview-src-list="[registerForm.logoUrl]" alt=""></el-image>
                                <div class="delete-icon" v-if="registerForm.logoUrl" @click="deleteUpImg(1)"><van-icon name="delete-o"></van-icon></div>
                            </div>
                            <div class="up-tip">请提供贵公司的 Logo 尺寸 1:1，格式 png 透明底</div>
                            <el-upload :action="baseUrl + '/Files/UploadAzureBlob'" :before-upload="(file) => beforeFile(1, file)" :on-success="(response, file, fileList) => successFile(1, response, file, fileList)">
                                <el-button size="small" type="info" :loading="loadings[0]"><i class="el-icon-upload2"></i>{{ registerForm.logoUrl ? '重新上传' : '上传' }}</el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item prop="certifications" label="证书图片" class="word_input">
                        <div class="upload-box">
                            <div class="up-img">
                                <el-image v-if="registerForm.certifications" :src="registerForm.certifications" :preview-src-list="[registerForm.certifications]" alt=""></el-image>
                                <div class="delete-icon" v-if="registerForm.certifications" @click="deleteUpImg(2)"><van-icon name="delete-o"></van-icon></div>
                            </div>
                            <div class="up-tip">请提供贵公司的 Aveva 合作伙伴证书，格式 jpg</div>
                            <el-upload :action="baseUrl + '/Files/UploadAzureBlob'" :before-upload="(file) => beforeFile(2, file)" :on-success="(response, file, fileList) => successFile(2, response, file, fileList)">
                                <el-button size="small" type="info" :loading="loadings[1]"><i class="el-icon-upload2"></i>{{ registerForm.certifications ? '重新上传' : '上传' }}</el-button>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item prop="expirationDate" label="证书有效期">
                        <el-date-picker v-model="registerForm.expirationDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择证书有效期"></el-date-picker>
                    </el-form-item>
                    <!-- <div class="privacy-text">
                        <el-checkbox v-model="privacy" class="flex">
                            我确认已阅读
                            <a href="https://www.aveva.cn/legal/privacy-policy/" target="_blank" >AVEVA 隐私政策</a>
                            并确认我的个人数据的处理详情。
                        </el-checkbox>
                    </div> -->
                    <el-form-item class="flex0">
                        <el-button type="info" size="medium" :loading="loading" @click="submitForm('registerForm')" class="pc-register loginBtn" >提 交</el-button>
                    </el-form-item>
                    </el-form>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { SavePartner } from '@/api/partner';
import { mapState } from 'vuex'
import { ApiToken } from '@/utils/ApiToken'
import breadcrumb from "@/components/Breadcrumb/index.vue";
import { GetUserInfo } from "@/api/profile.js";

export default {
    name: 'Partner-join',
    data() {
        return{
            // !面包屑
            refer: [
                { name: "首页", href: "/" },
                { name: "合作伙伴", href: "/Home/Partner" },
                { name: "马上加入" },
            ],
            baseUrl: ApiToken.baseApi,
            loading: false,
            loadings: [false, false, false],
            IsHaveCompany: false,
            // !所属类型
            typeList: [
                { id: 100, title: '分销商' },
                { id: 101, title: '解决方案供应商' },
                { id: 102, title: '金牌系统集成商' },
                { id: 103, title: '银牌系统集成商' },
            ],
            // !业务范围
            serviceList: [
                { id: 101, value: '1', title: '全线产品' },
                { id: 102, value: '2', title: '运营类产品' },
                { id: 103, value: '3', title: '工程设计产品' }
            ],

            registerForm: {
                cN_Name: "",
                eN_Name: "",
                type: "",
                business: "",
                abstract: "",
                contact: "",
                phone: "",
                email: "",
                websiteUrl: "",
                logoUrl: "",
                certifications: "",
                expirationDate: "",
            },
            rules: {
                cN_Name: [
                    { required: true, message: "请输入合作伙伴中文名", trigger: "blur" },
                ],
                eN_Name: [
                    { required: true, message: "请输入合作伙伴英文名", trigger: "blur" },
                ],
                type: [
                    { required: true, message: "请选择合作伙伴所属类型", trigger: "change" },
                ],
                business: [
                    { required: false, message: "请选择业务范围", trigger: "change" },
                ],
                abstract: [
                    { required: false, message: "请输入公司简介", trigger: "blur" },
                ],
                contact: [
                    { required: false, message: "请输入联系人", trigger: "blur" },
                ],
                phone: [
                    { required: false, message: "请输入联系电话", trigger: "blur" },
                    { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,message: "请输入正确的手机号",trigger: "blur"},
                ],
                email: [
                    { required: false, message: "请输入您的邮箱地址", trigger: "blur" },
                    { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
                ],
                websiteUrl: [
                    { required: false, message: "请输入公司官网", trigger: "blur" },
                    { type: "url", message: "请输入正确的官网地址", trigger: "blur" },
                ],
                logoUrl: [
                    { required: false, message: "请上传公司 logo", trigger: "blur" },
                ],
                certifications: [
                    { required: false, message: "请上传证书图片", trigger: "blur" },
                ],
                expirationDate: [
                    { required: true, message: "请选择证书有效期", trigger: "change" },
                ],
            },
        }
    },
    components: {
        breadcrumb,
    },
    methods: {
        // !文件上传前的回调
        beforeFile(type, file) {
            if (file.size > 1 * 1024 * 1024 * 1024) {
                this.$toast("文件大小超出所能上传的最大限制（1GB）")
                return false;
            }
            const filetype = '.' + file.name.split('.')[file.name.split('.').length - 1];
            switch (type) {
                case 1:
                if (filetype === '.png') {
                    this.loadings.splice(0, 1, true);
                } else {
                    this.$toast("上传文件格式与要求不符，请重新上传！");
                    return false;
                }
                break;
                case 2:
                if (filetype === '.jpg') {
                    this.loadings.splice(1, 1, true);
                } else {
                    this.$toast("上传文件格式与要求不符，请重新上传！");
                    return false;
                }
                break;
            }
        },
        // !文件上传成功回调
        successFile(type, response) {
            if (response.status == 1) {
                this.$toast("上传成功！");
                switch (type) {
                case 1:
                    this.registerForm.logoUrl = response.data.fileUrl;
                    this.loadings.splice(0, 1, false);
                    break;
                case 2:
                    this.registerForm.certifications = response.data.fileUrl;
                    this.loadings.splice(1, 1, false);
                    break;
                }
            } else {
                this.loadings.splice(type - 1, 1, false);
                this.$toast(response.message);
            }
        },
        // !删除图片
        deleteUpImg(type) {
            switch (type) {
                case 1:
                    this.registerForm.logoUrl = "";
                    break;
                case 2:
                    this.registerForm.certifications = "";
                    break;
            }
        },
        // !关闭弹窗
        closeDialog() {
            this.showDialog = false
            this.$refs.registerForm.resetFields(); 
            this.privacy = false;
            this.loading = false;
        },
        // !报名
        submitForm(formName) {
            console.log(this.registerForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // if (this.privacy) {
                        this.loading = true;
                        const registerForm = JSON.parse(JSON.stringify(this.registerForm))  
                        SavePartner(registerForm).then((res) => {
                            if (res.status == 1) {
                                this.$toast("提交成功！");
                                GetUserInfo().then((res) => {
                                    this.$store.dispatch('Profile', res.data);
                                    setTimeout(() => {
                                        this.loading = false;
                                        this.$router.push({
                                            path: '/Home/Partner',
                                        });
                                    }, 800);
                                });
                            } else{
                                this.loading = false;
                                this.$toast(res.message);
                            }
                        });
                    // } else {
                    //     this.$alert("请先阅读并勾选论坛协议！", "提示", {
                    //         confirmButtonClass: "el-button--mini",
                    //         callback: (action) => {},
                    //     });
                    //     return false;
                    // }
                } else {
                    this.loading = false;
                    return false;
                }
            });
        },
    },
    computed: {
        ...mapState(['clientWidth', 'Module', 'Infos']),
    },
    watch: {
        "$store.state.Infos": {
            immediate: true,
            handler(val) {
                if(val.company) {
                    this.registerForm.cN_Name = val.company;
                    this.IsHaveCompany = true;
                }
            }
        },
    },
    mounted() {
        if(this.Infos.isPartner) {
            this.$router.push('/Home/Partner');
        }
    }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
<style>
.el-image-viewer__wrapper{
    z-index: 100002 !important;
}
</style>